<template>
  <div id="app">
    <AdminHeader v-if='hasAdminMenu' />
    <Header v-if="hasHeader" />
    <span :style="`display:block; height:${topHeaderSpace}px;`" id='topNavSpacer'></span>
    <Sidebar />

    <router-view/>
  </div>
</template>


<script>
import $ from 'jquery'
import Header from './components/v2/Header';
import Sidebar from './components/Sidebar'
import AdminHeader from './components/AdminHeader'
import { getLocalStorage, log } from './app/helpers';
import { mapState } from 'vuex';

export default {
  mounted() {
    $(document).ready( () => {
      $('[data-toggle="tooltip"]').tooltip();
    })
    
    const storage = getLocalStorage('user', {});
    this.$store.commit('user', storage.user);

    const avatar = getLocalStorage('avatar', '');
    this.$store.commit('avatar', avatar);
  },
  data() {
    return {
      bodyClassAttr: this.bodyClass,
      hasAdminMenu: false,
    }
  },
  computed: {
    ...mapState(['user', 'hasHeader']),

    bodyClass() {
      return this.$store.state.bodyClass;
    },
    topHeaderSpace() {
      let height = 0;

      $(document).ready(() => {
        height += $('.navbar').height();
        $('#topNavSpacer').css('height', height);
      });

      if (this.user && this.user.hasAdminAccess) {
        $(document).ready( () => {
          const adminHeight = $('.admin-menu-top').height();
          height += adminHeight;
          $('.navbar').css({top: adminHeight});
          $('#topNavSpacer').css('height', height);
        });
      }

      return height;
    },
  },
  components: {
    Header, Sidebar,
    AdminHeader,
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      // document.body.className = '';
      this.$store.commit('hasHeader', true);
      this.$store.commit('isProgressBar', true);
    },
    bodyClass() {
      document.body.className = this.bodyClass;
    },
    user(value) {
      this.hasAdminMenu = !!(value && value.hasAdminAccess);
    },
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#topNavSpacer {
  min-height: 70px;
}
</style>
